import { NavLink } from "react-router-dom";

import { List, ListItem, ListItemText, makeStyles } from "@material-ui/core";

import palette from "src/styles/palette";
import { useFeatureFlag } from "src/util/featureFlags";

import BackToSubaccountListItem from "./BackToSubaccountListItem";

const useStyles = makeStyles(() => ({
  sidebar: {
    minHeight: "calc(100vh - 80px)",
    width: "240px",
    paddingTop: 20,
    background: palette.lightGray
  },
  sidebarItem: {
    fontSize: 16, // TODO: use Typography
    paddingLeft: 24
  }
}));

export default function OrgSidebar({
  baseUrl
}: {
  baseUrl: string;
}): JSX.Element {
  const usageEnabled = useFeatureFlag("usage");

  const items = [
    {
      label: "Organization Settings",
      path: `${baseUrl}/settings`
    },
    {
      label: "Manage Subaccounts",
      path: `${baseUrl}/subaccounts`
    },
    {
      label: "Organization Owners",
      path: `${baseUrl}/owners`
    },
    ...(usageEnabled
      ? [
          {
            label: "Usage",
            path: `${baseUrl}/usage`
          }
        ]
      : []),
    {
      label: "Data Exports",
      path: `${baseUrl}/exports`
    }
  ];

  const classes = useStyles();
  return (
    <div className={classes.sidebar}>
      <List>
        {items.map(({ label, path }, idx) => (
          <ListItem
            key={idx}
            dense
            button
            className={classes.sidebarItem}
            component={NavLink}
            to={path}
            activeStyle={{ fontWeight: 999 }}
          >
            <ListItemText disableTypography primary={label} />
          </ListItem>
        ))}
        <BackToSubaccountListItem className={classes.sidebarItem} />
      </List>
    </div>
  );
}
